export default __webpack_public_path__ + "static/media/image-artist-5.e95a37f5.jpg";